import { container } from "./ServiceContainer";
import { createServiceConfig } from "./ServiceConfig";
import LoginService from "@/services/LoginService";
import StatusService from "@/services/StatusService";
import { SessionOverrides } from "@/utils/queryParams";

// Service tokens
export const LOGIN_SERVICE_TOKEN = 'LoginService';
export const STATUS_SERVICE_TOKEN = 'StatusService';

export function registerServices(overrides?: SessionOverrides): void {
  const config = createServiceConfig(overrides);

  container.register(LOGIN_SERVICE_TOKEN, () => new LoginService(config));
  container.register(STATUS_SERVICE_TOKEN, () => new StatusService(config));
}

// Helper functions to get services
export function getLoginService(): LoginService {
  return container.get<LoginService>(LOGIN_SERVICE_TOKEN);
}

export function getStatusService(): StatusService {
  return container.get<StatusService>(STATUS_SERVICE_TOKEN);
}